// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__393NW","toggle":"styles_toggle__3RRW2","preview":"styles_preview__3Irxg"};